// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"c2458c79","217":"b85defb1","294":"48166a29","357":"2c066e4a","371":"1809fb28","453":"eb9b73df","550":"fc5edd71","615":"74758aa4","722":"ed71b99f","823":"2eb864ce","832":"98fbf3b3","855":"4e82d5bf","918":"f8a77b9e"}[chunkId] + ".chunk.js";
};